import React from 'react'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'

const Consent = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <FormControl fullWidth>
      <InputLabel>Consent Obtained</InputLabel>
      <Select
        value={moduleValues?.['Consent Obtained'] ?? ''}
        label="Consent Obtained"
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            ['Consent Obtained']: e.target.value,
          }))
        }
      >
        {['Yes', 'No', 'Unable'].map((x) => (
          <MenuItem key={x} value={x}>
            {x}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
)

export default Consent
